<mat-form-field class="col-12">
  <mat-label>Select a Plan</mat-label>
  <input
    #fiveTwoNineField
    class="w-100"
    type="text"
    matInput
    [formControl]="fiveTwoNineControl"
    [matAutocomplete]="auto"
    [class.mat-mdc-form-field-error]="
      fiveTwoNineControl.errors && fiveTwoNineControl.touched
    "
  />
  @if (fiveTwoNineControl.errors && fiveTwoNineControl.touched) {
    <mat-hint>This field is required</mat-hint>
  }
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="handle529($event)"
  >
    @for (plan of filtered529s | async; track plan) {
      <mat-option [value]="plan.PlanId">{{ plan.PlanName }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
